var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"align-start":"","justify-center":"","fill-height":""}},[_c('v-flex',{attrs:{"md10":"","lg8":""}},[_c('v-card',{attrs:{"height":"100%","width":"100%"}},[_c('bullet-list-loader',{staticStyle:{"width":"100%"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }